/**
 * api接口统一管理
 */
import { post } from '@/request/http'
// 查询全部导航栏
export const apiFindAll = p => post('/navigation/findAll', p)
// 根据id查询文章详情
export const apiArticleFindById = p => post('/article/findById', p)
// 首页
export const apiPageHome = p => post('/navigation/homePage', p)
